module.exports = __webpack_public_path__ + "img/info-black.0848bdee.svg";